import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * <SpotLight3D>: a cone light aimed at a target. Its SpotLightHelper gizmo
 * shows the angle, range and aim without relying on the illumination.
 */
import { useMemo, useRef } from 'react';
import { transformFromNode3DProperties } from '../../../../r3f/nodeTransform';
import { parseColorToHex } from '../../../../utils/colorParser';
import { godotConePenumbra } from '../../../../r3f/godotLightAttenuation';
import { degToRad } from '../../../../godot/math/math.js';
import { spotShadowBias } from '../shared/shadowBias';
import { spotLight3DAabb } from '../../../../godot/scene/light';
import { LightWithTarget } from '../shared/lightShared';
import { SpotLightGizmo } from '../shared/lightHelpers';
import { positionalLightRange, usePositionalLight } from '../shared/positionalLight';
export function SpotLight3D({ node, children }) {
    const properties = node.properties;
    const lightRef = useRef(null);
    const transform = useMemo(() => transformFromNode3DProperties(properties), [properties]);
    const color = parseColorToHex(properties.light_color);
    const { distance, shadowNear, shadowFar } = positionalLightRange(properties.spot_range);
    const angleRadians = degToRad(properties.spot_angle);
    const aabb = useMemo(() => spotLight3DAabb(properties.spot_range, properties.spot_angle), [properties.spot_range, properties.spot_angle]);
    // `spot_attenuation` is Godot's distance falloff exponent, which three calls decay.
    const decay = properties.spot_attenuation;
    const penumbra = godotConePenumbra(angleRadians, properties.spot_angle_attenuation);
    const { intensity, shadowOpacity, userData } = usePositionalLight(lightRef, properties, properties.spot_angle_attenuation);
    return (_jsx(LightWithTarget, { name: node.name, transform: transform, aabb: aabb, renderLight: (target) => (_jsxs(_Fragment, { children: [_jsx("spotLight", { ref: lightRef, position: [0, 0, 0], color: color, intensity: intensity, distance: distance, angle: angleRadians, penumbra: penumbra, decay: decay, castShadow: properties.shadow_enabled, "shadow-intensity": shadowOpacity, userData: userData, "shadow-camera-near": shadowNear, "shadow-camera-far": shadowFar, "shadow-bias": spotShadowBias(properties), target: target }), _jsx(SpotLightGizmo, { lightRef: lightRef })] })), children: children }));
}
//# sourceMappingURL=Component.js.map